module.exports = __webpack_public_path__ + "img/header_edit.f4c3de13.svg";